export const StepForwardCircleIcon = () => (
  <svg viewBox="0 0 130 130" fill="none" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.9" cx="64.5" cy="64.5" r="64.5" fill="#202020" />
    <path d="M60.59 47.42L65.17 52L60.59 56.59L62 58L68 52L62 46L60.59 47.42Z" fill="white" />
  </svg>
);
